import api from '../../../../App/socket';

export const getUserProfileAddresses = _id => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'Read',
        options: {
            limit: 1,
            where: { _id },
            attributes: ['person.addresses.country', 'person.addresses.street', 'person.addresses.city', 'person.addresses.state', 'person.addresses.zip_code'],
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_addresses_requests/get_user_addresses_request.js